import { formatImgUrl } from "../utils/cardFormating";
import { Group } from "../types";

export const useGroupDataFormatter = (group: Group) => {
  let name: string = "",
    firstTwoChr: string = "",
    id: number | null = null,
    about: string = "",
    description: string = "",
    createdAt: string = "",
    updatedAt: string = "",
    media: string = "";

  if (!group) {
    return {
      name: "",
      firstTwoChr: "",
      id: null,
      about: "",
      description: "",
      createdAt: "",
      updatedAt: "",
      media: "",
    };
  }

  name = group.name;
  firstTwoChr = group.name.slice(0, 2).toUpperCase();
  id = group.id;
  description = group.description;
  createdAt = group.createdAt;
  updatedAt = group.updatedAt;
  media = formatImgUrl(group.imageLink);

  return {
    name,
    firstTwoChr,
    id,
    about,
    description,
    createdAt,
    updatedAt,
    media,
  };
};
